import { WebSocketMessage } from '../types';

class WebSocketService {
  private ws: WebSocket | null = null;
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private reconnectInterval = 5000;
  private listeners: Map<string, Function[]> = new Map();
  private isConnected = false;

  connect(userId: string) {
    const wsUrl = process.env.REACT_APP_WS_URL || 'ws://localhost:5001/ws';
    

    
    try {
      this.ws = new WebSocket(wsUrl);

      this.ws.onopen = () => {
  
        this.isConnected = true;
        this.reconnectAttempts = 0;
        
        // Authenticate with the server
  
        this.send('auth', { userId });
      };

      this.ws.onmessage = (event) => {
        try {
          const message: WebSocketMessage = JSON.parse(event.data);
          this.handleMessage(message);
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      this.ws.onclose = () => {
  
        this.isConnected = false;
        this.attemptReconnect(userId);
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    } catch (error) {
      console.error('Failed to connect to WebSocket:', error);
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
      this.isConnected = false;
    }
  }

  send(type: string, payload?: any) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ type, payload }));
    } else {
      console.warn('WebSocket not connected, cannot send message');
    }
  }

  private handleMessage(message: WebSocketMessage) {
    const { type, payload } = message;
    
    
    const listeners = this.listeners.get(type) || [];
    
    
    listeners.forEach(callback => {
      try {
        callback(payload);
      } catch (error) {
        console.error(`Error in WebSocket listener for ${type}:`, error);
      }
    });
  }

  on(eventType: string, callback: Function) {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, []);
    }
    this.listeners.get(eventType)!.push(callback);
  }

  off(eventType: string, callback: Function) {
    const listeners = this.listeners.get(eventType);
    if (listeners) {
      const index = listeners.indexOf(callback);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }

  private attemptReconnect(userId: string) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;

      
      setTimeout(() => {
        this.connect(userId);
      }, this.reconnectInterval);
    } else {
      console.error('Max reconnection attempts reached');
    }
  }

  startSession(sessionId: string, keywords: string[] = []) {

    this.send('start_session', { sessionId, keywords });
  }

  joinSession(sessionId: string) {

    this.send('join_session', { sessionId });
  }

  leaveSession() {

    this.send('leave_session');
  }

  stopSession() {
    this.send('stop_session');
  }

  updateKeywords(keywords: string[]) {
    this.send('update_keywords', { keywords });
  }

  getConnectionStatus() {
    return this.isConnected;
  }
}

export const wsService = new WebSocketService(); 